import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardText } from 'material-ui/Card';
import ConfirmDialog from '../Common/ConfirmDialog';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SuccessSnackbar from "../Common/SuccessSnackbar";

import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EnrolmentIcon from 'material-ui/svg-icons/social/school';
import MailIcon from 'material-ui/svg-icons/content/send';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';
import SecurityIcon from 'material-ui/svg-icons/hardware/security';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';

import Gravatar from 'react-gravatar';

import { FormattedDate } from 'react-intl';
import { Link } from 'react-router';
import UserActions from '../../actions/UserActionCreator';
import DialogActions from '../../actions/DialogActionCreator';
import { CommonDialogs } from '../../constants/Dialogs';
import { DateStyles } from '../../constants/CentricConstants';
import Error404 from '../Pages/Error404';

import ROLES from '../../constants/Roles';
import AppStore from '../../stores/AppStore';

import UserStore from '../../stores/UserStore';
import { formatName } from '../../utils/StringUtils';
import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';
import DetailView from '../Common/DetailView';
import ComplianceContainer from '../Compliance/ComplianceContainer';
import UserSkillLContainer from './UserSkillContainer';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0
    },
    menuItem: {
        color: '#CC0000'
    },
    iconButton: {
        marginRight: '24px',
    },
    avatar: {
        borderRadius: '50%'
    }
};

const getMenuItems = (id, onDelete, onSendWelcomeEmail, onResetPassword) => [
    {
        link: `/dashboard/user/${id}/calendar`,
        icon: <CalendarIcon />,
        label: 'Calendar',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/courses/enrolments/user/${id}`,
        icon: <EnrolmentIcon />,
        label: 'Course enrolments',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/modules/enrolments/user/${id}`,
        icon: <ModuleIcon />,
        label: 'Module enrolments',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/user/${id}/activity`,
        icon: <TimeLineIcon />,
        label: 'Activity',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    { type: 'divider' },
    {
        action: onSendWelcomeEmail,
        icon: <MailIcon />,
        label: 'Send welcome email',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        action: onResetPassword,
        icon: <SecurityIcon />,
        label: 'Reset password',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/user/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/user/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete ',
        deleteAction: onDelete,
        message: (<span>Are you sure you want to delete this user?</span>),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

class User extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            error: false,
            details: {
                id: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                dateOfBirth: '',
                isAdmin: '',
                isManager: '',
                jobRole: '',
                username: '',
                email: '',
                organisation: '',
                organisationId: '',
                visits: '',
                lastLogin: '',
                dateWelcomeSent: null,
                dateAdded: '',
                extId: '',
                LRSId: '',
                uuid: '',
                authMethod: ''
            },
            actions: [],
            successMessage: null,
            dialog: null,
            links: {
                back: '/dashboard/users',
                edit: ''
            },
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onResetPassword = this.onResetPassword.bind(this);
        this.showAttributes = this.showAttributes.bind(this);
        this.onSendWelcomeEmailRequest = this.onSendWelcomeEmailRequest.bind(this);
        this.sendWelcomeEmail = this.sendWelcomeEmail.bind(this);
        this.closeDialog = this.closeDialog.bind(this);

        UserStore.addChangeListener(this.onChange);
        UserActions.getById(this.props.id);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.onChange);
    }

    render() {
        if (this.state.error) { return <Error404 />; }

        let flags = [];
        const fullName = formatName(this.state.details);
        if (this.state.details.isAdmin) { flags.push(<span key="a" className="flag-text">admin</span>); }
        if (this.state.details.isManager) { flags.push(<span key="m" className="flag-text">manager</span>); }

        const dateRegisteredFormatted = (!!this.state.details.dateAdded && <FormattedDate value={this.state.details.dateAdded} {...DateStyles.shortWeekday} />);
        const lastLoginFormatted = (!!this.state.details.lastLogin && <FormattedDate value={this.state.details.lastLogin} {...DateStyles.shortWeekday} />);
        const dateWelcomeSent = (!!this.state.details.dateWelcomeSent && <FormattedDate value={this.state.details.dateWelcomeSent} />);

        return (
            <DetailView
                title={fullName}
                backButton={true}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card">
                            <CardText>
                                <Gravatar
                                    email={this.state.details.email}
                                    default='https://cdn.premierit.com/images/icons/contact.png'
                                    size={100}
                                    style={style.avatar}
                                />
                            </CardText>
                            <CardText className="cent-card-text">
                                <div className='cent-flex-row'>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            <li><em>Name: </em>{fullName}</li>
                                            <li><em>Username: </em>{this.state.details.username}</li>
                                            <li><em>Email: </em>{this.state.details.email}</li>
                                            <li>
                                                <em>Organisation: </em>
                                                <Link to={`/dashboard/organisation/${this.state.details.organisationId}`}>
                                                    {this.state.details.organisation}
                                                </Link>
                                            </li>
                                            <li><em>Job role: </em>{this.state.details.jobRole}</li>
                                            <li>{flags}</li>
                                        </ul>
                                    </div>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            <li><em>Registered </em>{dateRegisteredFormatted}</li>
                                            <li><em>Last visit </em>{lastLoginFormatted}</li>
                                            <li>{this.state.details.visits} visits</li>
                                            {!!this.state.details.extId && (<li><em>Ext Id:</em>{this.state.details.extId}</li>)}
                                            <li><em>LRS Id: </em>{this.state.details.LRSId}</li>
                                            <li><em>Uuid: </em>{this.state.details.uuid}</li>
                                            <li><em>Authentication method: </em>{this.state.details.authMethod}</li>
                                        </ul>
                                    </div>
                                    <div className='cent-col-1'>
                                        {this.showAttributes()}
                                    </div>
                                </div>
                            </CardText>
                        </Card>
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        <UserSkillLContainer userId={this.props.id} />
                        {!!this.state.details.archived && (
                            <Card className="cent-card ">
                                <CardText>
                                    <RaisedButton label="Restore"
                                        onTouchTap={() => {
                                            this.setState({dialog: 'restore'});
                                            DialogActions.open(CommonDialogs.CONFIRM);
                                        }}
                                        secondary
                                        fullWidth
                                    />
                                </CardText>
                            </Card>
                        )}
                    </div>
                    <div className="cent-col-1">
                        <ComplianceContainer userId={this.props.id} />
                    </div>

                </div>
                <Dialog
                    title="Send Welcome Email"
                    open={this.state.dialog === 'welcome'}
                    modal={false}
                    onRequestClose={this.closeDialog}
                    actions={[
                        <FlatButton label="Cancel" onTouchTap={this.closeDialog} />,
                        <FlatButton label="Send" onTouchTap={() => this.sendWelcomeEmail(this.props.id)} />
                    ]}
                >
                    A welcome email was already sent to {fullName} on {dateWelcomeSent}. Send again?
                </Dialog>
                {this.state.dialog === 'restore' && (
                    <ConfirmDialog
                        title="Restore archived user"
                        message={`This action will restore ${fullName}`}
                        confirmButtonLabel="Restore"
                        onConfirm={() => UserActions.restoreArchivedUser(this.props.id)}
                    />
                )}
                {this.state.dialog === 'password' && (
                    <ConfirmDialog
                        title="Reset password"
                        message="Are you sure you want to reset the user's password?"
                        confirmButtonLabel="Reset"
                        onConfirm={() => UserActions.passwordReset({username: this.state.details.email})}
                    />
                )}
                <SuccessSnackbar message={this.state.successMessage} />
            </DetailView>
        )
    }

    onChange() {
        const details = UserStore.getById(this.props.id);
        if (!!details) {
            this.setState({
                details,
                actions: !!details.archived ? null : buildContextMenu(getMenuItems(this.props.id, this.onDelete, this.onSendWelcomeEmailRequest, this.onResetPassword), this.context.auth)
            });
        } else {
            this.setState({ error: true });
        }
    }

    onDelete(entityId) {
        if (entityId === this.props.id) {
            UserActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    }

    onResetPassword() {
        this.setState({dialog: 'password', successMessage: `Password reset email sent to ${formatName(this.state.details)}`});
        DialogActions.open(CommonDialogs.CONFIRM);
    }

    showAttributes() {
        let attributes = [];
        if (!!this.state.details.attributes) {
            attributes = this.state.details.attributes.map(({ name, value }, i) => <p key={i}>{name}: {value}</p>);
        }
        return attributes;
    }

    onSendWelcomeEmailRequest() {
        const successMessage = `A welcome email was successfully sent to ${formatName(this.state.details)}`;
        if (!this.state.details.dateWelcomeSent) {
            this.sendWelcomeEmail(this.props.id);
            this.setState({successMessage});
        } else {
            this.setState({ dialog: 'welcome', successMessage });
        }
    }

    sendWelcomeEmail(userId) {
        UserActions.sendWelcomeEmail(userId);
        this.closeDialog();
    }

    closeDialog() {
        this.setState({ dialog: null });
    }

}

User.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(User);
